import { createSlice } from "@reduxjs/toolkit";

const initialCategoriesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  categories: [],
  entities: [],
  attributeEntities: [],
  attributesGroupsEntities: [],
  attributesTotalCount: 0,
  attributesGroupsTotalCount: 0,
  category: null,
  categoryTreeData: {},
  isDownLoading: false,
  lastError: null,
  error: null,
  exportStatus: null, // for import or export
  exportUrl: null,
  checkedCategory: null,
  categoriesForExport: null,
  message: {
    error: null,
    success: null,
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const categoriesSlice = createSlice({
  name: "categories",
  initialState: initialCategoriesState,
  reducers: {
    catchError: (state, action) => {
      let error =
        action.payload.error.response && action.payload.error.response.data ? action.payload.error.response.data.errors : action.payload.error.message;
      if (error.constructor.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.message.success = null;
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    setMessageForUpdateCategory: (state, action) => {
      const { payload } = action;
      state.message.success = payload;
    },
    categoryCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { category, message } = action.payload;
      // category = {
      //   title: category.name,
      //   key: category.id,
      //   value: category.id,
      //   label: category.name,
      //   products_count: category.products_count,
      //   autoExpandParent: true,
      // };
      // const parentId = category.parent_id;
      // if (parentId) {
      //   state.entities.map((entity) => {
      //     if (entity.key === parentId) {
      //       state.entities.push(category);
      //       break;
      //     }else if(entity.children){
      //       entity.children.
      //     }
      //   });
      // } else {
      //   state.entities.push(category);
      // }
      state.entities.push(category);
      state.message.success = message;
    },

    categoriesFetched: (state, action) => {
      const { totalCount, entities, categories, categoryTreeData, categoriesForExport } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = totalCount;
      state.entities = entities;
      state.categories = categories;
      state.categoryTreeData = categoryTreeData;
      state.categoriesForExport = categoriesForExport;
    },
    setCategories: (state,action)=>{
      state.categories = action.payload
    },
    changeCategory: (state, action) => {
      const { id } = action.payload;
      state.category = id;
    },
    categoryAttributesFetched: (state, action) => {
      const { entities, totalCount } = action.payload;
      state.error = null;
      state.listLoading = false;
      state.attributeEntities = entities;
      state.attributesTotalCount = totalCount;
    },
    categoryAttributesGroupsFetched: (state, action) => {
      const { entities, totalCount } = action.payload;
      state.error = null;
      state.listLoading = false;
      state.attributesGroupsEntities = entities;
      state.attributesGroupsTotalCount = totalCount;
    },
    categoryAttributeSaved: (state, action) => {
      const { message, entity } = action.payload;
      state.error = null;
      state.actionsLoading = false;
      state.message.success = message;
      state.attributeEntities = state.attributeEntities.map((attribute) => {
        if (entity.id == attribute.id) {
          return entity;
        }
        return attribute;
      });
    },
    categoryAttributeGroupSaved: (state, action) => {
      const { message, entity } = action.payload;
      state.error = null;
      state.actionsLoading = false;
      state.message.success = message;
      state.attributesGroupsEntities = state.attributesGroupsEntities.map((attributesGroup) => {
        if (entity.id == attributesGroup.id) {
          return entity;
        }
        return attributesGroup;
      });
    },
    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
      }
    },
    updateImportStatus: (state, action) => {
      const { status, url } = action.payload;
      state.ImportStatus = status;
      state.ImportUrl = url;
    },
    successActionCompleted: (state) => {
      state.message.success = null;
    },
    errorActionCompleted: (state) => {
      state.message.error = null;
    },
    setCheckedCategory: (state, action) => {
      state.checkedCategory = action.payload.category;
    },
    updateStatus: (state, action) => {
      state.exportStatus = action.payload.status;
      state.exportUrl = action.payload.url;
    },
    updateDownLoadingStatus: (state, action) => {
      state.isDownLoading = action.payload;
    },
  },
});
